module.exports = __webpack_public_path__ + "static/media/thewest_covidtracker-lg.d678ae3d.png";